import { todaysFormattedDate } from "../Helpers";


function ArticleTemplates({
    setArticle,
    setImages,
    author
}) {

    const articleTemplates = {
        "Card Change": {
            "title": "Card change: [Card Name]",
            "subtitle": "",
            "author": author.username,
            "story_date": todaysFormattedDate(),
            "section": "releases",
            "content": "Change in card effects:@@]]//\nThe Recharge@@]]//\nPrevious Effect]]// Return 1 card in your String to your hand.//\nNew Effect]]// Return 1 Fighter or Aura in your String to your hand.//",
            "images": {
                "1": [
                    {
                    "src": "https://compressedplaymakercards.s3.us-west-1.amazonaws.com/i1pl17tscb.jpg",
                    "caption": null,
                    "link": "https://www.jothplaymaker.com/cards/1159",
                    "order": 0,
                    "alt_text": "The Recharge"
                    }
                ]
            },
            "news": true,
            "site_link": ""
        },
        "Card Changes": {
            "title": "Card changes m/d - m/d",
            "subtitle": "",
            "author": author.username,
            "story_date": todaysFormattedDate(),
            "section": "releases",
            "content": "Change in card effects:@@]]//\nPantheraMan@@]]//\nPrevious Effect]]// If you are first to go this round or you have the highest Enthusiasm, resolve 1 of the following effects://● Deal 2 piercing damage to a foe.//● Heal 2 HP and draw 1 Pluck.//\nNew Effect]]// Resolve 1 of the following effects. If you are first to go this round or you have the highest Enthusiasm, resolve both effects instead://● Deal 2 piercing damage to a foe.//● Heal 2 HP and draw 1 Pluck.//\n\nStar Map@@]]//\nPrevious Effect]]// Discard 3 unturned Cosmic/Mystic cards in your String; damage dealt by 1 Cosmic or Mystic Move in your String is treated as bypassing damage this turn.//\n<Trigger> During the Start Phase, if your hand/String has 7 or more Cosmic/Mystic cards, return this Item to your Active Pluck (This effect was intended to return the Item from the discard pile).//\nNew Effect]]// Discard 3 Cosmic/Mystic cards in your String; damage dealt by 1 Cosmic or Mystic Move in your String is treated as bypassing damage this turn.//\n<Trigger> During the Start Phase, if your hand/String has 7 or more Cosmic/Mystic cards, return this Item from your discard pile to your Reserve.//\n\nExperimental Dual Mode Thruster@@]]//\nPrevious Effect]]// <Trigger> During the Start Phase, discard 1 card from your hand; resolve 1 of the following effects://\nNew Effect]]// <Trigger> During the Start Phase or during a player's turn; resolve 1 of the following effects://\n\nHive@@]]//\nPrevious Effect]]//Draw 1 Pluck and reveal it; apply the following effects based on the Pluck revealed://\n<Item> Add 1 Move or MAX VARIABLE as a Move from your hand to your String.//\n<Event> Reset 1 Item.//\n<Comeback> Add 1 Aura, Move or MAX VARIABLE from the discard pile to your hand.//\nNew Effect]]// Draw 1 Pluck and reveal it; apply the following effects based on the Pluck revealed://\n<Item> Add 1 Move or MAX VARIABLE as a Move from your hand to your String.//\n<Event> You can resolve 1 additional Event this round.//\n<Comeback> Add 2 cards from the discard pile to your hand, then discard 1 card from your hand.//\n\nStinger Tornado!!!@@]]//\nPrevious Effect]]// 2 foes on your right.//\n<1-5> Deal 2 damage.//\nNew Effect]]// Foe on your left or right.//\n<1-5> Deal 2 piercing damage.//\n\"Pull 1 Hive Pluck\" added.//\n\nSpatial Reversal!!@@]]//\nPrevious Effect]]//\nThis card copies the effect text of an Aura or Move in a foe's String until the end of your turn (if the the selected card is face-down, reveal it).//\n<Trigger> If you are targeted for damage, your Fighter gains Redirect 1 (that card is revealed).//\nNew Effect]]//\nThis card copies the effect text of a Move in a foe's String until the end of your turn (if the the selected card is face-down, reveal it).//\n<Trigger> If you are targeted for damage, discard this unturned Move in your String; your Fighter gains Redirect 1 (that card is revealed).//\n\n\"The Trap Is Set!\"@@]]//\nPrevious Effect]]//\n<Trigger> During a foe's turn, deal 1 damage to that foe equal to total amount damage minus across all cards in their String (max of 3).//\nNew Effect]]//\n<Trigger> During a foe's turn, deal 1 true damage to that foe equal to total amount damage minus across all cards in their String (max of 3).//\n\nChange in card reactions:@@]]//\nHive@@]]//\nCounter 2 has been changed to Counter 1 and Endure 1.//\n\nChange in wordings:@@]]//\nOverclock and Overload@@]]//\nPrevious]]//\nAdd 1 card from the discard pile to your hand. All Tech and Energy cards in your String gain damage plus 1 (those cards deal 1 additional damage at the end of their resolutions). Take 1 damage 1 each time you resolve a card.//\nNew]]//\nAdd 1 card from the discard pile to your hand. All Tech and Energy cards in your String gain damage plus 1 (those cards deal 1 additional damage at the end of their resolutions). Take 1 damage 1 each time you resolve the main effect of a card this round.",
            "images": {
                "1": [
                    {
                    "src": "https://compressedplaymakercards.s3.us-west-1.amazonaws.com/i1g1pmf.jpg",
                    "caption": null,
                    "link": "https://www.jothplaymaker.com/cards/1001",
                    "order": 0,
                    "alt_text": "PantheraMan"
                    }
                ],
                "10": [
                    {
                    "src": "https://compressedplaymakercards.s3.us-west-1.amazonaws.com/i1plg15i.jpg",
                    "caption": null,
                    "link": "https://www.jothplaymaker.com/cards/1130",
                    "order": 0,
                    "alt_text": "Star Map"
                    }
                ],
                "17": [
                    {
                    "src": "https://compressedplaymakercards.s3.us-west-1.amazonaws.com/i1pl09dwi.jpg",
                    "caption": null,
                    "link": "https://www.jothplaymaker.com/cards/1091",
                    "order": 0,
                    "alt_text": "Experimental Dual Mode Thruster"
                    }
                ],
                "22": [
                    {
                    "src": "https://compressedplaymakercards.s3.us-west-1.amazonaws.com/i1b2hf.jpg",
                    "caption": null,
                    "link": "https://www.jothplaymaker.com/cards/1037",
                    "order": 0,
                    "alt_text": "Hive"
                    }
                ],
                "33": [
                    {
                    "src": "https://compressedplaymakercards.s3.us-west-1.amazonaws.com/i1b2he.jpg",
                    "caption": null,
                    "link": "https://www.jothplaymaker.com/cards/1040",
                    "order": 0,
                    "alt_text": "Stinger Tornado!!!"
                    }
                ],
                "41": [
                    {
                    "src": "https://compressedplaymakercards.s3.us-west-1.amazonaws.com/i1p2pm.jpg",
                    "caption": null,
                    "link": "https://www.jothplaymaker.com/cards/1055",
                    "order": 0,
                    "alt_text": "Spatial Reversal!!"
                    }
                ],
                "48": [
                    {
                    "src": "https://compressedplaymakercards.s3.us-west-1.amazonaws.com/i1pl17tse.jpg",
                    "link": "https://www.jothplaymaker.com/cards/1158",
                    "alt_text": "\"The Trap Is Set!\""
                    }
                ],
                "57": [
                    {
                    "src": "https://compressedplaymakercards.s3.us-west-1.amazonaws.com/i1plg11e.jpg",
                    "caption": null,
                    "link": "https://www.jothplaymaker.com/cards/1133",
                    "order": 0,
                    "alt_text": "Overclock and Overload"
                    }
                ]
            },
            "news": true,
            "site_link": "",
        },
        "New Card": {
            "title": "New card: [Card Name]",
            "subtitle": "",
            "author": author.username,
            "story_date": todaysFormattedDate(),
            "section": "releases",
            "content": "Right Back Up!@@]]//\nHero ID and Card Number:]]//R01 1162//\nType:]]//Comeback//\nSeries]]://Recoil, Energy, Brawler and Support//\nEffect]]://Take 2 damage; add 2 to your Focus. <C.Trigger> If a card in your play is defeated, add that card from the discard pile to your play with 4 damage tokens. The added card can not be resolved or used towards focus this round (you can not defend with the added card).",
            "images": {
                "0": [
                    {
                    "src": "https://compressedplaymakercards.s3.us-west-1.amazonaws.com/i1pl18rcb.jpg",
                    "link": "https://www.jothplaymaker.com/cards/1162",
                    "order": 1,
                    "alt_text": "Right Back Up!"
                    }
                ]
            },
            "news": true,
            "site_link": ""
        },
        "New Cards": {
            "title": "New cards m/d - m/d",
            "subtitle": "",
            "author": author.username,
            "story_date": todaysFormattedDate(),
            "section": "releases",
            "content": "Chakras Aligned@@]]//\nHero ID and Card Number:]]//GEN 1127//\nType:]]//Event//\nTag:]]//Max 1//\nSeries]]://Mystic, Quest and Relaxation//\nEffect]]:// Return 8 Mystic cards or pluck with different names from their respective discard piles to the bottom of your Main deck/Pluck deck in any order; all Mystic cards in your play gain damage plus 1 this round (those cards deal 1 additional damage at the end of their resolutions).//\n\nLucky Punch@@]]//\nHero ID and Card Number:]]//GEN 1128//\nType:]]//Event//\nTag:]]//Max 1//\nSeries]]://Brawler and Magic//\nEffect]]:// Discard 7 Pluck in your ownership; deal 5 piercing damage to a foe and ignore the reaction(s) of defending Fighter(s). Trigger effects can not be used in response to this Event.//",
            "images": {
                "0": [
                    {
                    "src": "https://compressedplaymakercards.s3.us-west-1.amazonaws.com/i1plg9e.jpg",
                    "caption": null,
                    "link": "https://www.jothplaymaker.com/cards/1123",
                    "order": 0,
                    "alt_text": "Chakras Aligned"
                    }
                ],
                "11": [
                    {
                    "src": "https://compressedplaymakercards.s3.us-west-1.amazonaws.com/i1plg10e.jpg",
                    "caption": null,
                    "link": "https://www.jothplaymaker.com/cards/1124",
                    "order": 0,
                    "alt_text": "Lucky Punch"
                    }
                ]
            },
            "news": true,
            "site_link": ""
        },
        "New Key Term": {
            "title": "Key term [term name] introduced",
            "subtitle": "",
            "author": author.username,
            "story_date": todaysFormattedDate(),
            "section": "game",
            "content": "The key term Start Phase has been introduced.//All text referring to the start of the round will be replaced with \"During the Start Phase\".",
            "images": {},
            "news": true,
            "site_link": "",
        },
        "New Key Terms": {
            "title": "New key terms introduced m/d - m/d",
            "subtitle": "",
            "author": author.username,
            "story_date": todaysFormattedDate(),
            "section": "game",
            "content": "The key terms Focus plus X, Focus minus X, Enthusiasm plus X and Enthusiasm minus X have been introduced.//\nAll text \"Add X to your Focus\" will be replaced by \"Focus plus X\".//\nAll text \"Lower the Focus of X foes by Y\" will be replaced by and \"X foes gain Focus minus Y\".//\nAll text \"Add X to your Enthusiasm\" will be replaced by \"Enthusiasm plus X\".//\nAll text \"Lower the Focus of X foes by Y\" will be replaced by and \"X foes gain Enthusiasm minus Y\".//",
            "images": {},
            "news": true,
            "site_link": "",
        }
    }

    const templateTypes = [
        "Card Change",
        "Card Changes",
        "New Card",
        "New Cards",
        "New Key Term",
        "New Key Terms"
    ]

    const handleTemplate = (templateType) => {
        if (templateType) {
            setArticle(articleTemplates[templateType])
            const processedImages = []
            for (let keyName of Object.keys(articleTemplates[templateType].images)) {
                for (let order of Object.keys(articleTemplates[templateType].images[keyName])) {
                    console.log(articleTemplates[templateType].images[keyName][order].src)
                    const image = {
                        keyName: keyName,
                        src: articleTemplates[templateType].images[keyName][order].src??null,
                        alt_text: articleTemplates[templateType].images[keyName][order].alt_text??null,
                        caption: articleTemplates[templateType].images[keyName][order].caption??null,
                        order: order,
                        link: articleTemplates[templateType].images[keyName][order].link??null,
                    }
                    processedImages.push(image)
                }
            }
            setImages(processedImages)
        }
    };

    const handleDropDown = (event) => {
        const selectedTemplate = event.target.value;
        handleTemplate(selectedTemplate)
    }

    return (
        <div className="cd-measure margin-auto">
            <h2 className="label">Article Samples</h2>
            <select
                className="builder-input"
                type="text"
                onChange={handleDropDown}>
                <option value="">
                    Select Sample
                </option>
                {templateTypes.map((templateType) => (
                    <option key={templateType} value={templateType}>
                        {templateType}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default ArticleTemplates;
